import { jsx as _jsx } from "preact/jsx-runtime";
import { Suspense, lazy } from 'preact/compat';
import getContainerColours from '@/lib/getContainerColours';
import { captureException } from '@/lib/sentry';
// The blank svg takes up the same space as a wheeled bin would whilst the icon is loading
import BlankSvg from './svg/blank.svg?react';
const containerNameToSvgName = {
    Box: 'box',
    'Communal Wheeled Bin': 'communal-bin',
    'Householder Provided Carrier Bag': 'carrier-bag',
    'Inner Caddy': 'inner-caddy',
    'Kerbside Caddy': 'caddy',
    'Kitchen Caddy': 'caddy',
    'Reusable Sack': 'sack',
    'Non-Reusable Sack': 'sack',
    'Wheeled Bin': 'wheeled-bin',
    Trolibocs: 'trolibocs',
    'Trolibocs - Top box': 'trolibocs-multi',
    'Trolibocs - Middle box': 'trolibocs-multi',
    'Trolibocs - Bottom box': 'trolibocs-multi',
    'Trolibocs – 3 containers': 'trolibocs-multi',
};
export default function ContainerSvg({ name, lidColour, bodyColour, label, colours, }) {
    if (!name || name === 'undefined') {
        return null;
    }
    const ContainerIconSvg = lazy(() => {
        return import(`./svg/${containerNameToSvgName[name]}.svg?react`).catch((error) => {
            captureException(error, {
                component: 'ContainerSvg',
                containerName: name,
            });
            return Promise.resolve({ default: BlankSvg });
        });
    });
    const cssVariables = getContainerColours(name, bodyColour, lidColour, colours);
    return (_jsx(Suspense, { fallback: BlankSvg, children: _jsx(ContainerIconSvg, { className: "container-svg", "aria-label": label, "aria-hidden": !label, style: cssVariables }) }));
}
